import React, {useState} from 'react';
import PropTypes from 'prop-types';

function DocumentViewerComponent({filename, alternateViewer, width, height}) {
    const [erroredOut, setErroredOut] = useState(false);

    return (
        alternateViewer ? (
            <iframe
                title="doc-viewer"
                src={`https://view.officeapps.live.com/op/embed.aspx?src=${filename}`}
                frameBorder="0"
                style={{
                    height: height || '50vh',
                    width: width || '750px'
                }}
            />
        ) : (
            <iframe
                title="doc-viewer"
                src={`https://docs.google.com/viewer?url=${filename}&embedded=true`}
                frameBorder="0"
                style={{
                    height: height || '50vh',
                    width: width || '500px'
                }}
            />
        )
    );
}

DocumentViewerComponent.propTypes = {
    filename: PropTypes.string.isRequired,
    alternateViewer: PropTypes.bool,
    width: PropTypes.string,
    height: PropTypes.string
};

export default DocumentViewerComponent;
